import React from "react"

import { Tabs } from "~components/Tabs"
import CodeSample from "./CodeSample"

const PRISM_LANGUAGES = {
  curl: "curl",
  ts_gen: "typescript",
  python_gen: "python",
  dotnet_gen: "csharp",
  swift_gen: "swift",
  java_gen: "java",
  java: "java",
  python: "py",
  py: "py",
  dotnet: "csharp",
  swift: "swift",
  node: "js",
  "c#": "csharp",
  cs: "csharp",
  csharp: "csharp",
  js: "js",
  javascript: "js",
  ios: "swift",
  bash: "bash",
  sh: "bash",
  shell: "bash",
  json: "json",
  yaml: "yaml",
  ini: "ini",
}

const PRIORITIES = Object.keys(PRISM_LANGUAGES)
const byPriority = (a, b) => PRIORITIES.indexOf(a.language) - PRIORITIES.indexOf(b.language)

const TabbedCodeBlocks = ({ samples }) => (
  <div data-role="code-sample">
    <Tabs>
      {samples.sort(byPriority).map((sample) => (
        <CodeSample key={sample.id} sample={sample} />
      ))}
    </Tabs>
  </div>
)

export default TabbedCodeBlocks
export { PRISM_LANGUAGES }
